import axios from "axios";
import { Dispatch } from "redux";
import {
  VehicleActionTypes,
  GET_VEHICLES_SUCCESS,
  GET_VEHICLES_FAILURE,
  SET_VEHICLES_LOADING,
  GET_VEHICLES_BY_VIN,
  GET_VEHICLES_BY_VIN_SUCCESS,
  GET_VEHICLES_BY_VIN_FAILURE,
  GET_FEETYPES,
  GET_FEETYPES_SUCCESS,
  GET_FEETYPES_FAILURE,
  GET_POPULAR_CARS,
  GET_POPULAR_CARS_SUCCESS,
  GET_POPULAR_CARS_FAILURE,
  GET_TOP_DEAL_CARS,
  GET_TOP_DEAL_CARS_SUCCESS,
  GET_TOP_DEAL_CARS_FAILURE,
} from "../types/vehicleTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

// Fetch vehicles action
export const fetchVehicles =
  (
    page: number,
    limit: number,
    sortBy: string,
    from_date: string,
    to_date: string,
    filters = {}
  ) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: SET_VEHICLES_LOADING });

    try {
      const response = await API.get("/vehicles", {
        params: { page, limit, from_date, to_date, sort: sortBy, ...filters },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      dispatch({
        type: GET_VEHICLES_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: GET_VEHICLES_FAILURE,
        payload: error.response?.data?.message || "Failed to fetch vehicles",
      });
    }
  };

export const getVehicleByVin = (data: any) => async (dispatch: Dispatch) => {
  dispatch({
    type: GET_VEHICLES_BY_VIN,
    payload: [],
  });

  try {
    const response = await API.get("/vehicles/" + data?.vin, {
      params: {
        from_date: data?.from_date,
        to_date: data?.to_date,
      },

      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    dispatch({
      type: GET_VEHICLES_BY_VIN_SUCCESS,
      payload: response.data,
    });
  } catch (error: any) {
    dispatch({
      type: GET_VEHICLES_BY_VIN_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch vehicles",
    });
  }
};

export const getFeeTypes =
  (data: any) => async (dispatch: Dispatch<VehicleActionTypes>) => {
    try {
      dispatch({ type: GET_FEETYPES, payload: [] });
      const response = await API.get("/feetypes?status=" + data?.status, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: GET_FEETYPES_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_FEETYPES_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_FEETYPES_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getPopularCars =
  (data: any) => async (dispatch: Dispatch<VehicleActionTypes>) => {
    try {
      dispatch({ type: GET_POPULAR_CARS, payload: [] });
      const response = await API.get(
        "/vehicles/popular/cartypes?make=" + data?.make,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (response.status) {
        dispatch({ type: GET_POPULAR_CARS_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_POPULAR_CARS_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_POPULAR_CARS_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getDealVehicles =
  () => async (dispatch: Dispatch<VehicleActionTypes>) => {
    try {
      dispatch({ type: GET_TOP_DEAL_CARS, payload: [] });
      const response = await API.get("/top-deal-vehicles", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: GET_TOP_DEAL_CARS_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_TOP_DEAL_CARS_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_TOP_DEAL_CARS_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };
